<template>
    <v-row>
        <v-col>
            <v-list subheader :style="'height: 50vh; overflow: auto'" lines="two">
                <v-list-subheader> Voici les sociétés à regrouper </v-list-subheader>
                <v-list-item
                    v-for="company in toMergeCompanies"
                    :key="company.id"
                    class="oss-list-item mb-2"
                >
                    <v-list-item-title style="text-overflow: ellipsis; max-width: 600px">
                        {{ company.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>{{ company.siret }}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{ company.groupKey }}</v-list-item-subtitle>
                    <div class="body-2">{{ company.address }} {{ company.city }}</div>
                </v-list-item>
                <v-list-item
                    class="oss-list-item my-1"
                    style="background: #fff"
                    v-if="toMergeCompaniesLoading"
                >
                    <v-skeleton-loader ref="skeleton" type="list-item-three-line" />
                </v-list-item>
            </v-list>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import COMPANY_FROM_IDS from "../graphql/company/CompaniesFromIds.gql";
import GROUPKEYS_MERGE from "../graphql/company/GroupKeysMerge.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["merge-done"],
})
export class MergeGroupKeys extends Vue {
    @Prop({ default: [] }) companiesId: Array<any>;
    @Prop({ default: null }) actions: any;

    beforeMount() {
        if (this.actions?.action) {
            this.actions.action.function = this.groupKeysMerge;
            // this.actions.action.hideValid = false
            this.actions.action.title = "Valider le groupement";
        }
    }

    @Apollo({
        query: COMPANY_FROM_IDS,
        variables() {
            return {
                companyIds: this.companiesId.map((company) => company.id),
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    if (data.companies) {
                        if (this.infiniteScroll) this.toMergeCompanies.push(...data.companies);
                        else this.toMergeCompanies = data.companies;
                    } else {
                        this.toMergeCompanies = [];
                    }
                }
            }
        },
    })
    toMergeCompanies: Array<any> = [];

    get toMergeCompaniesLoading() {
        if (this.$apollo.queries.companies) {
            return this.$apollo.queries.companies.loading;
        }
        return false;
    }

    async groupKeysMerge() {
        await this.$apollo.mutate({
            mutation: GROUPKEYS_MERGE,
            variables: {
                companies: this.companiesId,
            },
        });

        this.$emit("merge-done");
    }
}

export default toNative(MergeGroupKeys);
</script>
